// extracted by mini-css-extract-plugin
export default {"pricingCard":"BasePricingCard_pricingCard__OqVG9","title":"BasePricingCard_title__-JI1g"};